export const MOCK_RESPONSE = {
    errorCode: 0,
    errorDescription: 'SUCCESS',
    errorMessage: null,
    response: [{
        accountNumber: '511000000',
        accountType: 'FINL',
        accountStatus: 'Active',
        accountLinked: false,
        acctEmails: [{
            emailSeqNum: 0,
            emailAddress: '511EMAIL24@A.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'ABAC@A.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'AMRITHA@GMIAL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'AMUTHUSAMY@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'ARAMOHAN@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'ASHUSTER@PERSHING.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'AUXILLARY@GMAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'BRINDAID3TEST@GMAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'BRINDAID5TEST@GMAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'JNDFJGDFGDFIDFI@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'JOHNCC@JOHN2.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'KAVIJ@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'MADAN@GMAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'MAHESHNN021@GMAIL.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'MOHINI.JAISWAL@PERSHING.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'MOHINI.N.JAISWAL@GMAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'PANANDALWAR@PERSHING.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'PAVIIJ@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'PAVIJ@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'PAVIJAYA@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'PAVIJAYAKUMAR@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'RRAJAPPAN@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'SECOND@GMAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'SURJAYARAM@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'TEST1@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'TEST2@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'TEST@PERSHING.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'TESTING@PERSHING.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'WILL@GMAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'WILLS@GMAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'testingemailsync@gmail.com',
            oldEmailAddress: null,
            emailIndex: 0
        }],
        edelElgible: true,
        strCorrNum: '511',
        strOfcNum: '511',
        strRrNum: '511',
        shortName: 'TESTACCTS',
        address: 'PERSHING AUTOMATION SOD 9/12 NEW ACCOUNT TEST ACCOUNT UPDATE C/O NEW ACNT 9TH FLOOR PERSHING PERSHING TEL:(201)413-2685  (973)360-2808',
        externalEmailAddr: 'TEST1@INAUTIX.CO.IN',
        ssn: '132741529',
        subscriberEmails: null,
        edeliveryDocuments: [{
            docEligible: true,
            documentsIncluded: null,
            pin: null,
            preferenceType: {
                preferenceCode: 'PAPER',
                deliveryPreference: 1,
                preferenceCodeMF: 'P'
            },
            effectiveDate: {
                weekDay: 2,
                javaDate: 1532464425249
            },
            enrolled: false,
            edocumentType: {
                docType: 1,
                docTypeCd: 'STMT',
                docTypeDesc: 'Statements and Reports',
                docTypeCdMF: 'S'
            }
        }, {
            docEligible: true,
            documentsIncluded: null,
            pin: null,
            preferenceType: {
                preferenceCode: 'ONLINE',
                deliveryPreference: 2,
                preferenceCodeMF: 'E'
            },
            effectiveDate: {
                weekDay: 2,
                javaDate: 1532464425250
            },
            enrolled: false,
            edocumentType: {
                docType: 2,
                docTypeCd: 'CNFM',
                docTypeDesc: 'Trade Confirmations',
                docTypeCdMF: 'C'
            }
        }, {
            docEligible: true,
            documentsIncluded: ['PMAS'],
            pin: null,
            preferenceType: {
                preferenceCode: 'PAPER',
                deliveryPreference: 1,
                preferenceCodeMF: 'P'
            },
            effectiveDate: {
                weekDay: 2,
                javaDate: 1532464425250
            },
            enrolled: false,
            edocumentType: {
                docType: 5,
                docTypeCd: 'QPR',
                docTypeDesc: 'Quarterly Performance Reports',
                docTypeCdMF: 'Q'
            }
        }, {
            docEligible: true,
            documentsIncluded: null,
            pin: null,
            preferenceType: {
                preferenceCode: 'ONLINE',
                deliveryPreference: 2,
                preferenceCodeMF: 'E'
            },
            effectiveDate: {
                weekDay: 2,
                javaDate: 1490733225250
            },
            enrolled: false,
            edocumentType: {
                docType: 4,
                docTypeCd: 'TAXD',
                docTypeDesc: 'Tax Documents',
                docTypeCdMF: 'T'
            }
        }, {
            docEligible: true,
            documentsIncluded: null,
            pin: null,
            preferenceType: {
                preferenceCode: 'PAPER',
                deliveryPreference: 1,
                preferenceCodeMF: 'P'
            },
            effectiveDate: {
                weekDay: 1,
                javaDate: 1359408825250
            },
            enrolled: false,
            edocumentType: {
                docType: 3,
                docTypeCd: 'NOTF',
                docTypeDesc: 'Notifications',
                docTypeCdMF: 'M'
            }
        }, {
            docEligible: true,
            documentsIncluded: null,
            pin: '0456',
            preferenceType: {
                preferenceCode: 'ONLINE',
                deliveryPreference: 2,
                preferenceCodeMF: 'E'
            },
            effectiveDate: {
                weekDay: 2,
                javaDate: 1532464425250
            },
            enrolled: false,
            edocumentType: {
                docType: 7,
                docTypeCd: 'PRXY',
                docTypeDesc: 'Proxy/Shareholder Communications',
                docTypeCdMF: 'X'
            }
        }, {
            docEligible: true,
            documentsIncluded: ['Mutual Fund', 'ETF', 'UIT'],
            pin: null,
            preferenceType: {
                preferenceCode: 'ONLINE',
                deliveryPreference: 2,
                preferenceCodeMF: 'E'
            },
            effectiveDate: {
                weekDay: 2,
                javaDate: 1532464425250
            },
            enrolled: false,
            edocumentType: {
                docType: 6,
                docTypeCd: 'PROS',
                docTypeDesc: 'Prospectus',
                docTypeCdMF: 'R'
            }
        }]
    }, {
        accountNumber: '511000010',
        accountType: 'PART',
        accountStatus: 'Active',
        accountLinked: false,
        acctEmails: [{
            emailSeqNum: 0,
            emailAddress: 'ABAC@A.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'ADSF@ASDF.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'AMRITHA@GMIAL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'AMUTHUSAMY@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'ASHUSTER@PERSHING.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'AUXILLARY@GMAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'BCD@GMAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'BMATHIAZAGAN@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'BRINDAID3TEST@GMAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'BRINDAID5TEST@GMAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'DFIORE@PERSHING.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'GRAMACHANDRAN@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'JAPALANIAPPAN@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'KAVIJ@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'MADAN@GMAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'MOHINI.JAISWAL@PERSHING.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'MOHINI.N.JAISWAL@GMAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'OCHESTER@PERSHING.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'PAVIJAYA@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'PRIM@MAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'RANBAZHAGAN@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'RRAJAPPAN@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'SDURAISAMY@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'SEC@MAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'SECOND@GMAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'SGOPAL@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'SPERI@PERSHING.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'SRS@PERSHING.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'SSABLAN@AAA.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'SUBASH@GMAOIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'TEST1@PERSHING&GT;COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'TEST3@PERSHING.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'TEST@INAUTIX.CO.IN',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'TEST@INAUTIX.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'TESTING@PERSHING.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'WEB123@PERSHING.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'WILL@GMAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'WILLS@GMAIL.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'XXXX@ABC.COM',
            oldEmailAddress: null,
            emailIndex: 0
        }, {
            emailSeqNum: 0,
            emailAddress: 'paviNew83.k@gmail.com',
            oldEmailAddress: null,
            emailIndex: 0
        }],
        edelElgible: true,
        strCorrNum: '511',
        strOfcNum: '511',
        strRrNum: 'A86',
        shortName: 'JAME',
        address: 'NEW TITLE 11                    US LINE ONE                     PENNINGTON NJ 08534',
        externalEmailAddr: null,
        ssn: '111223300',
        subscriberEmails: null,
        edeliveryDocuments: [{
            docEligible: true,
            documentsIncluded: null,
            pin: null,
            preferenceType: {
                preferenceCode: 'ONLINE',
                deliveryPreference: 2,
                preferenceCodeMF: 'E'
            },
            effectiveDate: {
                weekDay: 5,
                javaDate: 1519421625250
            },
            enrolled: false,
            edocumentType: {
                docType: 1,
                docTypeCd: 'STMT',
                docTypeDesc: 'Statements and Reports',
                docTypeCdMF: 'S'
            }
        }, {
            docEligible: true,
            documentsIncluded: null,
            pin: null,
            preferenceType: {
                preferenceCode: 'ONLINE',
                deliveryPreference: 2,
                preferenceCodeMF: 'E'
            },
            effectiveDate: {
                weekDay: 5,
                javaDate: 1519421625250
            },
            enrolled: false,
            edocumentType: {
                docType: 2,
                docTypeCd: 'CNFM',
                docTypeDesc: 'Trade Confirmations',
                docTypeCdMF: 'C'
            }
        }, {
            docEligible: true,
            documentsIncluded: ['PMAS'],
            pin: null,
            preferenceType: {
                preferenceCode: 'ONLINE',
                deliveryPreference: 2,
                preferenceCodeMF: 'E'
            },
            effectiveDate: {
                weekDay: 2,
                javaDate: 1484084025250
            },
            enrolled: false,
            edocumentType: {
                docType: 5,
                docTypeCd: 'QPR',
                docTypeDesc: 'Quarterly Performance Reports',
                docTypeCdMF: 'Q'
            }
        }, {
            docEligible: true,
            documentsIncluded: null,
            pin: null,
            preferenceType: {
                preferenceCode: 'ONLINE',
                deliveryPreference: 2,
                preferenceCodeMF: 'E'
            },
            effectiveDate: {
                weekDay: 2,
                javaDate: 1484084025250
            },
            enrolled: false,
            edocumentType: {
                docType: 4,
                docTypeCd: 'TAXD',
                docTypeDesc: 'Tax Documents',
                docTypeCdMF: 'T'
            }
        }, {
            docEligible: true,
            documentsIncluded: null,
            pin: null,
            preferenceType: {
                preferenceCode: 'ONLINE',
                deliveryPreference: 2,
                preferenceCodeMF: 'E'
            },
            effectiveDate: {
                weekDay: 2,
                javaDate: 1484084025250
            },
            enrolled: false,
            edocumentType: {
                docType: 3,
                docTypeCd: 'NOTF',
                docTypeDesc: 'Notifications',
                docTypeCdMF: 'M'
            }
        }, {
            docEligible: true,
            documentsIncluded: null,
            pin: null,
            preferenceType: {
                preferenceCode: 'PAPER',
                deliveryPreference: 1,
                preferenceCodeMF: 'P'
            },
            effectiveDate: {
                weekDay: 3,
                javaDate: 1534970025250
            },
            enrolled: false,
            edocumentType: {
                docType: 7,
                docTypeCd: 'PRXY',
                docTypeDesc: 'Proxy/Shareholder Communications',
                docTypeCdMF: 'X'
            }
        }, {
            docEligible: true,
            documentsIncluded: ['Mutual Fund', 'ETF', 'UIT'],
            pin: null,
            preferenceType: {
                preferenceCode: 'PAPER',
                deliveryPreference: 1,
                preferenceCodeMF: 'P'
            },
            effectiveDate: {
                weekDay: 3,
                javaDate: 1534970025250
            },
            enrolled: false,
            edocumentType: {
                docType: 6,
                docTypeCd: 'PROS',
                docTypeDesc: 'Prospectus',
                docTypeCdMF: 'R'
            }
        }]
    }]
};
